export default "__VITE_ASSET__C4qI0n$m__"